import {
	Create,
	Edit,
	List,
	SimpleForm,
	BooleanInput,
	ReferenceArrayInput,
	TextInput,
	required,
	AutocompleteArrayInput,
	Datagrid,
	TextField,
	EditButton,
	ReferenceManyField,
	DataTable,
	useRecordContext
} from 'react-admin';
import { default as icon } from '@mui/icons-material/Groups';
import { Typography } from '@mui/material';

const list = () =>
    <List>
		<Datagrid>
			<TextField source="name" />
			<EditButton />
		</Datagrid>
    </List>;

const OrbList = () => {
	const record = useRecordContext();

	return record?.id ? 	
		<>
			<Typography>Orbs</Typography>
			<ReferenceManyField reference="orbs" target="group_id">
				<DataTable rowClick="edit" bulkActionButtons={false}>
					<DataTable.Col source="name" />
					<DataTable.Col source="description" />
				</DataTable>

			</ReferenceManyField>
		</>
		: null;
};

const FormFields = (
	<SimpleForm>
		<TextInput source="name" validate={required()} />
		<ReferenceArrayInput reference="users" source="user_ids">
			<AutocompleteArrayInput source="name" label="Users" />
		</ReferenceArrayInput>
		<BooleanInput source="active" defaultValue={true} />
		<OrbList />
	</SimpleForm>
);

const edit = () => <Edit>{FormFields}</Edit>;
const create = () => <Create>{FormFields}</Create>;

export const Group = { list, edit, create, icon };
export default Group;